export default __webpack_public_path__ + "static/1134-38f91fefe3ecd38d255c1c2209405cfb.gif";